module.exports = __webpack_public_path__ + "static/media/path.5267b0b1.svg";